import {AssetType} from "./index";
import {RoutePath} from "../../../../types";

const getAssetDetailPageLink = (id: number, assetType: AssetType, organizationId?: number) => {
    let route;
    switch (assetType) {
        case AssetType.EETS:
            route = `${RoutePath.ORGANIZATIONS}/${organizationId}/${RoutePath.EETS_DEVICES}`;
            break;
        case AssetType.DSX3:
            route = `${RoutePath.DEVICES}`;
            break;
        case AssetType.KPN:
        case AssetType.CO3:
        case AssetType.UNKNOWN:
            route = "";
            break;
    }
    return `/${route}/${id}`;
};

export default getAssetDetailPageLink;
